import { render, staticRenderFns } from "./ModalComentarios.vue?vue&type=template&id=f26ee0aa"
import script from "./ModalComentarios.vue?vue&type=script&lang=js"
export * from "./ModalComentarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports